import { Controller } from 'stimulus';
import Cookies from 'js-cookie';
import MediaMatcher from 'lib/media-matcher';
import { padZero } from 'lib/helpers';

const mediaMatcher = new MediaMatcher();

export default class SiteBannerController extends Controller {
  static targets = ['countdown']

  bannerSlug = null;

  countdownTimer = null;

  connect() {
    this.bannerSlug = this.element.dataset.slug;
    document.body.classList.add('has-bottom-banner');

    if (this.hasCountdownTarget) {
      mediaMatcher.addMediaQuery('(min-width: 850px)',
        () => { this.startCountdownClock(); },
        () => { if (this.countdownTimer) clearInterval(this.countdownTimer); });

      mediaMatcher.evaluateAll();
      mediaMatcher.addListeners();
    }
  }

  disconnect() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);

    mediaMatcher.removeListeners();
    mediaMatcher.clearQueries();
  }

  dismiss = (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.setDismissedCookie();
    document.body.classList.remove('has-bottom-banner');

    this.element.remove();
  }

  setDismissedCookie() {
    Cookies.set(`${this.bannerSlug}_banner_dismissed`, 'internal', { domain: this.cookieDomain });
  }

  startCountdownClock() {
    // Remove after Black Friday sale if unneeded
    // w3c special: https://www.w3schools.com/howto/howto_js_countdown.asp

    const countdownDate = new Date(this.countdownTarget.dataset.countdownEnd).getTime();
    const { countdownPrefix } = this.countdownTarget.dataset;
    let firstRun = true;

    this.countdownTimer = setInterval(() => {
      const now = new Date().getTime();
      const distance = countdownDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (days) {
        this.countdownTarget.innerHTML = `${countdownPrefix}: ${days}:${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)} `;
      } else {
        this.countdownTarget.innerHTML = `${countdownPrefix}: ${hours}:${padZero(minutes)}:${padZero(seconds)} `;
      }

      if (firstRun) {
        this.element.classList.add('countdown-started');
        firstRun = false;
      }

      if (distance < 0) clearInterval(this.countdownTimer);
    }, 1000);
  }

  get cookieDomain() {
    const cookieDomainArray = window.location.hostname.split('.');
    return `${cookieDomainArray[1]}.${cookieDomainArray[2]}`;
  }
}
